import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
// import CurrencyInput from 'react-currency-input';
import { read_cookie, delete_cookie } from 'sfcookies';
import Axios from 'axios';
import Helmet from 'react-helmet';
import $ from 'jquery';
import NumericInput from 'react-numeric-input';

class PaymentCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      abonentInfo: {},
      custN: '',
      amount: '',
      amounterror: false,
      data: {},
      merch_id: '',
      page_id: '',
      back_url_s: '',
      back_url_f: '',
      order_id: '',
      payredirect: false,
      src: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setState({ custN: this.props.match.params.customerId });
    const token = read_cookie('Bearer_Token');
    const name = window.$name;
    if (this.props.match.params.customerId) {
      Axios.post(
        `${name}/api/Payment/Check`,
        {
          customerNumber: this.props.match.params.customerId,
        },
        {
          headers: {
            Token: token,
          },
        }
      )
        .then((res) => {
          //console.log(res);
          if (res.data.abonentInfo === null) {
            alert('აბონენტის ინფორმაციის წამოღება ვერ მოხერხდა');
          } else if (res.data.abonentInfo.error > 0) {
            alert('აბონენტის არასწორი ნომერი');
          } else {
            this.setState({ abonentInfo: res.data.abonentInfo, data: res.data });
            if (res.data.abonentInfo.balance > 0) {
              this.setState({ amount: res.data.abonentInfo.balance });
            }
          }
        })
        .catch((error) => {
          if (error.code === 401) {
            delete_cookie('Bearer_Token');
            window.location.href = '/login';
          }
        });
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  handleChange = (input) => (e) => {
    this.setState({ [input]: e });

    //console.log(e);
    if (e === '' || e === '0.00') {
      //console.log(1);
      this.setState({ amounterror: false });
    } else {
      this.setState({ amounterror: true });
    }
  };

  setPayRedirect = (url) => {
    this.setState({
      src: url,
      payredirect: true,
    });
  };

  renderPayRedirect = () => {
    if (this.state.payredirect) {
      let src = this.state.src;
      return <Redirect push to={{ pathname: '/dashboard/MobilePay', state: { src: src } }} />;
    }
  };

  reverseString(str) {
    return str.split('').reverse().join('');
  }

  render() {
    let customer = this.state.abonentInfo;
    let data = this.state.data;
    var _ = this;
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);

    $('#payForm').submit(function (event) {
      if (check) {
        var url = `${data.url}?` + $('#payForm').serialize();
        if (url !== data.url) {
          _.setPayRedirect(url);
        }

        event.preventDefault();
      }
    });

    let temp = window.location.href;
    let path = '';
    for (let i = temp.length - 1; i > 0; i--) {
      if (temp[i] == '/') break;
      path += temp[i];
    }

    path = this.reverseString(path);

    if (path == 'MobilePay') {
      this.state.payredirect = false;
    }

    return (
      <React.Fragment>
        {this.renderPayRedirect()}
        <Helmet>
          <title>გადახდა</title>
        </Helmet>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card">
              <div className="card-header" style={{ textAlign: 'center' }}>
                <span style={{ fontFamily: 'BPGCaps', fontSize: '1.5rem', color: '#262262' }}>
                  აბონენტის №: <span>{this.props.match.params.customerId}</span>
                </span>
              </div>
              <div
                className="card-body"
                style={{ textAlign: 'center', fontFamily: 'BPGCond', color: '#262262' }}
              >
                <form
                  className="form-horizontal"
                  id="payForm"
                  method="get"
                  action={this.state.data.url}
                  target="_blank"
                >
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12 col-sm-12"
                      style={{ textAlign: 'center', margin: 'auto' }}
                    >
                      <div className="col-md-9 col-sm-12 col-lg-8">
                        <div className="form-group row" style={{ textAlign: 'left' }}>
                          <label className="col-md-5 col-lg-5 col-sm-12 col-form-label">
                            <strong>აბონენტი:</strong>
                          </label>
                          <label className="col-md-7 col-lg-7 col-sm-12 col-form-label">
                            {customer.fullName}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-9 col-sm-12 col-lg-8">
                        <div className="form-group row" style={{ textAlign: 'left' }}>
                          <label className="col-md-5 col-lg-5 col-sm-12 col-form-label">
                            <strong>მისმართი:</strong>
                          </label>
                          <label className="col-md-7 col-lg-7 col-sm-12 col-form-label">
                            {customer.address}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-9 col-sm-12 col-lg-8">
                        <div className="form-group row" style={{ textAlign: 'left' }}>
                          <label className="col-md-5 col-lg-5 col-sm-12 col-form-label">
                            <strong>დავალიანება:</strong>
                          </label>
                          <label className="col-md-7 col-lg-7 col-sm-12 col-form-label">
                            {customer.balance}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-9 col-sm-12 col-lg-8">
                        <div className="form-group row" style={{ textAlign: 'left' }}>
                          <label className="col-md-5 col-lg-5 col-sm-12 col-form-label">
                            <strong>ბოლო ვადა:</strong>
                          </label>
                          <label className="col-md-7 col-lg-7 col-sm-12 col-form-label">
                            {customer.paymentdeadline}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-9 col-sm-12 col-lg-8">
                        <div className="form-group row" style={{ textAlign: 'left' }}>
                          <label className="col-md-5 col-lg-5 col-form-label">
                            <strong>გადასახდელი თანხა:</strong>
                          </label>
                          &nbsp;&nbsp;
                          <NumericInput
                            autoFocus
                            required
                            min={0}
                            max={999999.99}
                            step={0.1}
                            precision={2}
                            className={`form-control${
                              this.state.amount === '0.00' ||
                              this.state.amount === '' ||
                              this.state.amount === '0'
                                ? ' is-invalid'
                                : ''
                            }`}
                            name="o.amount"
                            placeholder="0.00"
                            value={this.state.amount}
                            onChange={this.handleChange('amount')}
                          ></NumericInput>
                          {/* &nbsp;&nbsp;<CurrencyInput autoFocus className={`col-md-3 col-lg-4 col-sm-6 form-control${this.state.amount==="0.00"||this.state.amount==="" ||this.state.amount==="0"?" is-invalid":""}`} name="o.amount" placeholder="₾0.00" maxLength={11} onChange={this.handleChange("amount")} value={this.state.amount}></CurrencyInput> */}
                          {/* <NumberInput format="0,0[.]00"     id="price" value={this.state.amount} min={0} max={99999.99} onChange={this.handleChange("amount")} className={`col-md-3 form-control${this.state.amount==="0.00"||this.state.amount==="" ||this.state.amount==="0"?" is-invalid":""}`} ></NumberInput> */}
                          {/* <input className="col-md-2 form-control" placeholder="0.00" type="number" step="0.1" min="0.5" pattern="^\d*(\.\d{1,2})?$" max="999999.99"></input> */}
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-12">
                        <div className="form-group row">
                          <div className=" col-lg-1"></div>
                          <div className="col-md-6 col-lg-5" style={{ textAlign: 'center' }}>
                            <Link className="btn btn-secondary btn-lg" to={'/dashboard/Payment'}>
                              <i className="fas fa-arrow-circle-left"></i>&nbsp;უკან დაბრუნება
                            </Link>
                          </div>
                          <br />
                          <br />
                          <br />
                          <div className="col-md-5 col-lg-5" style={{ textAlign: 'center' }}>
                            <button
                              className="btn btn-primary btn-lg"
                              style={{ backgroundColor: '#262262', borderColor: '#262262' }}
                              type={
                                this.state.amount === '0.00' ||
                                this.state.amount === '' ||
                                this.state.amount === '0'
                                  ? 'button'
                                  : 'submit'
                              }
                            >
                              <i className="fas fa-shopping-cart"></i>&nbsp;გადახდა
                            </button>
                          </div>
                          <div className="col-md-1 col-lg-1"></div>
                        </div>
                        <input type="hidden" name="lang_code" value="ka"></input>
                        <input type="hidden" name="merch_id" value={data['merch_id']}></input>
                        <input type="hidden" name="page_id" value={data['page_id']}></input>
                        <input type="hidden" name="back_url_s" value={data['back_url_s']}></input>
                        <input type="hidden" name="back_url_f" value={data['back_url_f']}></input>
                        <input type="hidden" name="o.order_id" value={data['o.order_id']}></input>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PaymentCustomer;
